<template>
    <div class="signin-bg">
        <header>
            <!--logo-->
            <div class="logo">
                <img src="../assets/search/logo.png" alt=""/>
            </div>
            <!--中间导航区域-->
            <ul  class="nav">
                <li><router-link :to="{name:'Photography'}">摄影图片</router-link></li>
                <li><router-link :to="{name:'Vector'}">矢量图片</router-link></li>
                <!--<li><router-link :to="{name:'Video'}">优质视频</router-link></li>-->
                <li  class="active"><router-link :to="{name:'UserCenter'}">用户中心</router-link></li>
                <li><router-link :to="{name:'Dashboard'}">控制面板</router-link></li>
            </ul>
            <!--右边个人信息区域-->
            <div class="loging">
                <div class="kefu">
                    <img src="../assets/search/kf.png"  alt=""/>
                </div>
                <div class="tishi">
                    <img src="../assets/search/ts.png" alt=""/>
                    <span class="num">5</span>
                </div>
                <div class="userneme">
                    <span>欢迎，</span>
                    <span class="name">hellworld</span>
                </div>
                <div class="user-down">
                    <img src="../assets/search/jt.png" class="" alt=""/>
                    <ul class="grzx">
                        <li><a href="">个人中心1</a></li>
                        <li><a href="">个人中心2</a></li>
                        <li><a href="">个人中心3</a></li>
                        <li><a href="">个人中心4</a></li>
                    </ul>
                </div>
            </div>
        </header>
        <main>
            <div class="publicPopup">
                <el-dialog
                        title=""
                        :visible.sync="dialogVisible"
                        :before-close="handleClose">
                    <div class="popup-msg">
                        <h3>编辑个人信息</h3>
                        <div>
                        <el-form ref="popupForm" :model="popupForm"  :rules="rules">
                            <el-form-item label="姓名" prop="name">
                                <el-input v-model="popupForm.name" placeholder=""></el-input>
                            </el-form-item>
                            <el-form-item label="手机" prop="tel">
                                <el-input v-model="popupForm.tel" placeholder="用作登入系统的账号"></el-input>
                            </el-form-item>
                            <el-form-item label="登入密码" prop="pass">
                                <el-input v-model="popupForm.pass" placeholder="密码至少8位，必须包含数字和字母"></el-input>
                            </el-form-item>
                            <el-form-item label="确认密码" prop="againPass">
                                <el-input v-model="popupForm.againPass" placeholder="密码至少8位，必须包含数字和字母"></el-input>
                            </el-form-item>

                            <el-button class="submit" @click="submitForm('popupForm')">确定</el-button>
                        </el-form>
                        </div>
                    </div>
                    <span slot="footer" class="dialog-footer">

                    </span>
                </el-dialog>
            </div>
            <div class="main-content container-md">
                <div class="left-list">
                    <h3>用户中心</h3>
                    <ul>
                        <li :class="{'curr':UserCenter[0].value}" @click="UserCenter={},UserCenter[0].value">已购素材</li>
                        <li :class="{'curr':UserCenter[1].value}" @click="UserCenter={},UserCenter[1].value">小样记录</li>
                        <li :class="{'curr':UserCenter[2].value}" @click="UserCenter={},UserCenter[2].value">浏览记录</li>
                        <li :class="{'curr':UserCenter[3].value}" @click="UserCenter={},UserCenter[3].value =true">我的收藏</li>
                    </ul>
                </div>

                <div class="content-msg">
                    <div class="top-msg">
                        <h3>卖鱼的小官</h3>
                        <ul>
                            <li>
                                <span class="user"></span>用户组：市场部
                            </li>
                            <li>
                                <span class="money"></span>余额：30
                            </li>
                            <li @click="dialogVisible = true">
                                <span class="edit"></span>编辑个人信息
                            </li>
                        </ul>
                    </div>
                    <!--已购素材-->
                    <div class="search-msg" v-if="UserCenter.material" name="已购素材">
                        <div class="search">
                            <div class="lt">
                                <span class="type curr">素材类型</span>
                                <span class="id">素材ID</span>
                            </div>
                            <div class="rt">
                                <div class="date">
                                    <span>3.26</span> <i>-</i> <span>4.7</span>
                                </div>
                                <div class="bt">
                                    <a><img src="../assets/personal/search.png" alt="" width="20"/></a>
                                    <a>导出</a>
                                </div>
                            </div>
                        </div>
                        <div class="conditions">
                            <ul>
                                <li><span class="all curr"></span>全选</li>
                                <li><span class="yes"></span>生成授权书</li>
                                <li><span class="down"></span>下载授权书</li>
                            </ul>
                        </div>
                        <div class="content">
                            <ul>
                                <li>
                                    <div class="img">
                                        <span class="all curr"></span>
                                        <img src="../assets/personal/ipadpro_5th.jpg" alt="" />
                                        <div class="img-msg">
                                            <dl>
                                                <dd>素材ID：30357729</dd>
                                                <dd>分辨率：1678×1119px20M</dd>
                                                <dd>下载日期：2020-3-20</dd>
                                            </dl>
                                            <dl>
                                                <dd>类型：摄影图片</dd>
                                                <dd>尺寸：5.59×3.73cm</dd>
                                                <dd>大小：20M</dd>
                                            </dl>
                                        </div>
                                    </div>
                                    <div class="is-pass">
                                        被授权方
                                        上海诠寅信息科技有限公司
                                        <a>转授权</a>
                                    </div>
                                    <div class="download">
                                        <a>下载素材</a>
                                        <a>生成授权书</a>
                                        <a>下载授权书(0)</a>
                                    </div>
                                </li>
                                <li>
                                    <div class="img">
                                        <span class="all curr"></span>
                                        <img src="../assets/personal/ipadpro_5th.jpg" alt="" />
                                        <div class="img-msg">
                                            <dl>
                                                <dd>素材ID：30357729</dd>
                                                <dd>分辨率：1678×1119px20M</dd>
                                                <dd>下载日期：2020-3-20</dd>
                                            </dl>
                                            <dl>
                                                <dd>类型：摄影图片</dd>
                                                <dd>尺寸：5.59×3.73cm</dd>
                                                <dd>大小：20M</dd>
                                            </dl>
                                        </div>
                                    </div>
                                    <div class="is-pass">
                                        被授权方
                                        上海诠寅信息科技有限公司
                                        <a>转授权</a>
                                    </div>
                                    <div class="download">
                                        <a>下载素材</a>
                                        <a>生成授权书</a>
                                        <a>下载授权书(0)</a>
                                    </div>
                                </li>
                                <li>
                                    <div class="img">
                                        <span class="all curr"></span>
                                        <img src="../assets/personal/ipadpro_5th.jpg" alt="" />
                                        <div class="img-msg">
                                            <dl>
                                                <dd>素材ID：30357729</dd>
                                                <dd>分辨率：1678×1119px20M</dd>
                                                <dd>下载日期：2020-3-20</dd>
                                            </dl>
                                            <dl>
                                                <dd>类型：摄影图片</dd>
                                                <dd>尺寸：5.59×3.73cm</dd>
                                                <dd>大小：20M</dd>
                                            </dl>
                                        </div>
                                    </div>
                                    <div class="is-pass">
                                        被授权方
                                        上海诠寅信息科技有限公司
                                        <a>转授权</a>
                                    </div>
                                    <div class="download">
                                        <a>下载素材</a>
                                        <a>生成授权书</a>
                                        <a>下载授权书(0)</a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!--小样记录-->
                    <div class="search-msg" v-if="UserCenter.small" name="小样记录">
                        <div class="search">
                            <div class="lt">
                                <span class="type curr">素材类型</span>
                                <span class="id">素材ID</span>
                            </div>
                            <div class="rt">
                                <div class="date">
                                    <span>3.26</span> <i>-</i> <span>4.7</span>
                                </div>
                                <div class="bt">
                                    <a><img src="../assets/personal/search.png" alt="" width="20"/></a>
                                    <a>导出</a>
                                </div>
                            </div>
                        </div>
                       <!-- <div class="conditions">
                            <ul>
                                <li><span class="all curr"></span>全选</li>
                                <li><span class="yes"></span>生成授权书</li>
                                <li><span class="down"></span>下载授权书</li>
                            </ul>
                        </div>-->
                        <div class="content">
                            <ul>
                                <li>
                                    <div class="img">
                                        <span class="all curr"></span>
                                        <img src="../assets/personal/ipadpro_5th.jpg" alt="" />
                                        <div class="img-msg">
                                            <dl>
                                                <dd>素材ID：30357729</dd>
                                                <dd>分辨率：1678×1119px20M</dd>
                                                <dd>下载日期：2020-3-20</dd>
                                            </dl>
                                            <dl>
                                                <dd>类型：摄影图片</dd>
                                                <dd>尺寸：5.59×3.73cm</dd>
                                                <dd>大小：20M</dd>
                                            </dl>
                                        </div>
                                    </div>
                                   <!-- <div class="is-pass">
                                        被授权方
                                        上海诠寅信息科技有限公司
                                        <a>转授权</a>
                                    </div>-->
                                    <div class="download">
                                        <a>下载素材</a>
                                      <!--  <a>生成授权书</a>
                                        <a>下载授权书(0)</a>-->
                                    </div>
                                </li>
                                <li>
                                    <div class="img">
                                        <span class="all curr"></span>
                                        <img src="../assets/personal/ipadpro_5th.jpg" alt="" />
                                        <div class="img-msg">
                                            <dl>
                                                <dd>素材ID：30357729</dd>
                                                <dd>分辨率：1678×1119px20M</dd>
                                                <dd>下载日期：2020-3-20</dd>
                                            </dl>
                                            <dl>
                                                <dd>类型：摄影图片</dd>
                                                <dd>尺寸：5.59×3.73cm</dd>
                                                <dd>大小：20M</dd>
                                            </dl>
                                        </div>
                                    </div>
                                  <!--  <div class="is-pass">
                                        被授权方
                                        上海诠寅信息科技有限公司
                                        <a>转授权</a>
                                    </div>-->
                                    <div class="download">
                                        <a>下载素材</a>
                                       <!-- <a>生成授权书</a>
                                        <a>下载授权书(0)</a>-->
                                    </div>
                                </li>
                                <li>
                                    <div class="img">
                                        <span class="all curr"></span>
                                        <img src="../assets/personal/ipadpro_5th.jpg" alt="" />
                                        <div class="img-msg">
                                            <dl>
                                                <dd>素材ID：30357729</dd>
                                                <dd>分辨率：1678×1119px20M</dd>
                                                <dd>下载日期：2020-3-20</dd>
                                            </dl>
                                            <dl>
                                                <dd>类型：摄影图片</dd>
                                                <dd>尺寸：5.59×3.73cm</dd>
                                                <dd>大小：20M</dd>
                                            </dl>
                                        </div>
                                    </div>
                                   <!-- <div class="is-pass">
                                        被授权方
                                        上海诠寅信息科技有限公司
                                        <a>转授权</a>
                                    </div>-->
                                    <div class="download">
                                        <a>下载素材</a>
                                      <!--  <a>生成授权书</a>
                                        <a>下载授权书(0)</a>-->
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!--浏览记录-->
                    <!--<div class="search-msg"  v-if="UserCenter.browse" name="浏览记录">
                        <div class="search">
                            <div class="lt">
                                <span class="type curr">素材类型</span>
                                <span class="id">素材ID</span>
                            </div>
                            <div class="rt">
                                <div class="date">
                                    <span>3.26</span> <i>-</i> <span>4.7</span>
                                </div>
                                <div class="bt">
                                    <a><img src="../assets/personal/search.png" alt="" width="20"/></a>
                                    <a>导出</a>
                                </div>
                            </div>
                        </div>
                        <div class="content collection">
                            <div class="date">
                                <p>03/12</p>
                                <p>2020</p>
                            </div>
                            <div class="img">
                                <p>摄影图片</p>
                                <ul>
                                    <li v-for="(item, index)  in UserCenter[0].my" :key="index">
                                        <div v-if="item.media_type != '视频'">
                                            <img :src="item.cover_pic" alt=""/>
                                        </div>
                                        <div v-else>
                                            <video :src="item.cover_pic" controls="controls"></video>
                                        </div>
                                       &lt;!&ndash; <div class="operation">
                                            <span>{{item.media_id}}</span>
                                            <a>移除<img src="../assets/personal/cancel-gray.png" alt=""></a>
                                        </div>&ndash;&gt;
                                    </li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                </ul>
                            </div>
                        </div>
                    </div>-->
                    <!--我的收藏-->
                    <div class="search-msg"  v-if="this.UserCenter[3].value" name="我的收藏">
                        <div class="search">
                            <div class="lt">
                                <el-select v-model="materialType" placeholder="素材类型" value-key="">
                                    <el-option
                                            v-for="item in materialSelect"
                                            :key="item.mediaType"
                                            :label="item.mediaType"
                                            :value="item.name">
                                    </el-option>
                                </el-select>
                                <el-input v-model="mediaId" placeholder="素材ID"></el-input>
                            </div>
                            <div class="rt">
                                <div class="date">
                                    <span>3.26</span> <i>-</i> <span>4.7</span>
                                </div>
                                <div class="bt">
                                    <a><img src="../assets/personal/search.png" alt="" width="20"/></a>
                                    <a>导出</a>
                                </div>
                            </div>
                        </div>

                        <div class="content collection">
                            <div class="date">
                                <p>03/12</p>
                                <p>2020</p>
                            </div>
                            <div class="img">
                                <p>摄影图片</p>
                                <ul>
                                    <li v-for="(item, index)  in this.UserCenter[3].value" :key="index">
                                        <div v-if="item.media_type != '视频'">
                                            <img :src="item.cover_pic" alt=""/>
                                        </div>
                                        <div v-else>
                                            <video :src="item.cover_pic" controls="controls"></video>
                                        </div>
                                        <div class="operation">
                                            <span>{{item.media_id}}</span>
                                            <a>移除<img src="../assets/personal/cancel-gray.png" alt=""></a>
                                        </div>
                                    </li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <footer>
            <p>ALL  RIGHTS  RESERVED.广州影美晴信息科技有限责任公司  粤B2-20150265 | 粤网文  （2018）</p>
        </footer>
    </div>
</template>

<script>
    export default {
        name: 'Register',
        data() {
            return {
                UserCenter:[
                    {
                        material: false,
                        value: false,
                    },
                    {
                        small: false,
                        value: false,
                    },
                    {
                        browse: false,
                        value: false,
                    },
                    {
                        my: false,
                        value: false,
                    },
                ],
                dialogVisible: false,
                popupForm:{
                    name:'',
                    tel:'',
                    pass:'',
                    againPass:'',
                },
                rules: {
                    name: [
                        { required: true, message: '请输入活动名称', trigger: 'blur' },
                        { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                    ],
                    tel: [
                        { required: true, message: '请输入活动名称', trigger: 'blur' },
                        { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                    ],
                    pass: [
                        { required: true, message: '请输入活动名称', trigger: 'blur' },
                        { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                    ],
                    againPass: [
                        { required: true, message: '请输入活动名称', trigger: 'blur' },
                        { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                    ]
                },
                //我的收藏
                favoriteList:{},
                historyList:{},
                smallList:{},
                boughtList:{},
                materialSelect:[
                    {
                        mediaType: '1',
                        name: '图片'
                    },{
                        mediaType: '2',
                        name: '视频'
                    }
                ],
                materialType:'',
                mediaId:'',
            }
        },
        mounted() {
            this.FavoriteList()

        },
        methods: {
            //
            FavoriteList(){
                this.$post('/favourite/getlist',{mediaId:'',description:'',mediaType:''})
                    .then( res => {
                    if(res.code == 200){
                       /* this.UserCenter.material = res.data.result
                        this.UserCenter.small = res.data.result
                        this.UserCenter.browse = res.data.result*/
                        this.UserCenter = res.data.result
                        this.UserCenter[3].my = true
                        console.log(this.UserCenter,'this.UserCenter[0].mythis.UserCenter[0].mythis.UserCenter[0].my')
                    }
                }).catch(error => {
                    console.log(error.msg)
                })
            },
            HistoryList(){
                this.$post('/favourite/getlist',{mediaId:'',description:'',mediaType:''})
                    .then( res => {
                        if(res.code == 200){
                            /* this.UserCenter.material = res.data.result
                             this.UserCenter.small = res.data.result
                             this.UserCenter.browse = res.data.result*/
                            this.UserCenter.my = res.data.result
                        }
                    }).catch(error => {
                    console.log(error.msg)
                })
            },
            SmallList(){
                this.$post('/favourite/getlist',{mediaId:'',description:'',mediaType:''})
                    .then( res => {
                        if(res.code == 200){
                            /* this.UserCenter.material = res.data.result
                             this.UserCenter.small = res.data.result
                             this.UserCenter.browse = res.data.result*/
                            this.UserCenter.my = res.data.result
                        }
                    }).catch(error => {
                    console.log(error.msg)
                })
            },
            BoughtList(){
                this.$post('/favourite/getlist',{mediaId:'',description:'',mediaType:''})
                    .then( res => {
                        if(res.code == 200){
                            /* this.UserCenter.material = res.data.result
                             this.UserCenter.small = res.data.result
                             this.UserCenter.browse = res.data.result*/
                            this.UserCenter.my = res.data.result
                        }
                    }).catch(error => {
                    console.log(error.msg)
                })
            },
            handleClose(done) {
                done();
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        alert('submit!');
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    }
</script>


<style scoped>
    * {  padding: 0; margin: 0; box-sizing: border-box; }
    a {text-decoration: none;color:#333;  }
    div, b, p, h1, h2, h3, h4, h5, h6,ul, li, dl, dd, header, footer {  margin: 0;  padding: 0;  list-style: none;  }
    em, i, b, strong {font-style: normal;font-weight: normal;}
    .ct{text-align: center;}
    .fl{float: left}
    .fr{float: right}
    .pr{position: relative}
    .pa{position: absolute}
    .hd{overflow: hidden;}
    img{vertical-align: top;}
    header{width: 100%;height: 70px;background: #fff;padding: 0 40px 0 30px;display: flex;justify-content: space-between;line-height: 70px;}
    header .logo{margin-top: 16px;}
    header .nav,header .loging{display: flex;justify-content: space-between;}
    .nav li{margin: 0 20px;text-align: center;}
    .nav li.active::after{content:"";display:block;background: #FF9F00;height: 2px;width:80%;margin: -15px auto 0; }
    .nav li.active{font-weight: 600;}
    .loging .kefu img,.loging .tishi img{margin: 17px 20px 0;}
    .tishi{position: relative;}
    .tishi span.num{position: absolute;background: #E74C3A;border-radius:10px;color: #fff;min-width: 20px;height: 20px;font-size: 14px;text-align: center;line-height: 20px;display: inline-block;top:15px;right: 15px;padding: 0 4px;}
    .loging .user-down img{margin: 30px 10px 0}
    .user-down{cursor: pointer;position: relative;}
    .jiantou{ transform: rotate(180deg); -webkit-transform: rotate(180deg)}

    .swiper-slide a img{width:100%;height: 500px;}
    .banner >>> .swiper-pagination-bullet{width: 35px;height: 3px;background:#000;border-radius: 1px;opacity: .3;}
    .banner >>> .swiper-pagination-bullet-active{background:#FF9F00;opacity: 1}
    .serch{background: #fff;height: 60px;display: flex;justify-content: space-between;position: absolute;bottom: 60px;z-index: 11111111;left: 50%;margin-left: -360px;}
    .xiala{font-size: 14px;}
    .dropdown{width: 110px;text-align: center;line-height: 60px;cursor: pointer;}
    .inpt{width: 510px;padding-left: 5px;position: relative;}
    input{border: none;height: 60px;line-height: 60px;width: 100%;padding-left:40px;outline:none;font-size: 16px;}
    input::-webkit-input-placeholder {color:#666; font-size: 14px; }
    input:-moz-placeholder {color:#666; font-size: 14px; }
    input::-moz-placeholder {color:#666;font-size: 14px;  }
    input:-ms-input-placeholder {color:#666; font-size: 14px; }
    .icon-scrch{width: 110px;background: #FF9F00;text-align: center;}
    .icon-scrch img{margin-top: 16px;cursor: pointer;}

    .xiala img{margin-top: 24px;}
    .inpt img{margin-top: 18px;position: absolute;}
    .dropdown {position: relative;}
    .dropdown_menu {background: #fff;position: absolute;top: 60px;right: 0px;z-index: 1000;display: none;width: 110px;padding:10px 0;text-align: center;border-top: 1px solid #ddd;}
    .dropdown_menu dd{line-height: 34px!important;}
    .dropdown dl dd a {color: #333;line-height: 34px;font-size:14px;}
    .top-arrow1,.top-arrow2 {width:0;height:0;display:block;position:absolute;left:30px;top:-17px;z-index:5; /*����ie8-*/ border-top:8px transparent dashed;border-left:6px transparent dashed;border-right:6px transparent dashed;border-bottom:8px white solid;overflow:hidden;}
    .top-arrow1 {border-bottom:9px #ddd solid;}
    .top-arrow2 {top:-15px;border-bottom:9px #fff solid;}

    .img-all{padding: 50px 0;}
    .title{margin: 0 auto 50px;font-size: 26px;font-weight: 600;text-align: center;}
    .pubu{width: 1200px;margin: 0 auto;overflow: hidden;}
    .pubu li{border-radius: 10px;overflow: hidden;position: relative;float:left;margin:5px;cursor: pointer;}
    .pubu li:hover .zhezhao{display: none;}
    .pubu li .zhezhao{background: rgba(0,0,0,.2);position: absolute;top:0;right: 0;width: 100%;height: 100%;text-align: center;color: #fff;font-size: 22px;font-weight: 600;}
    .pubu li .zhezhao span{position: relative;top:50%;display: block;height: 30px;line-height: 30px;margin-top: -15px;}
    /*��������*/
    .hot-serch{padding: 50px 0;background: #F7F7F7;}
    .dbg{background: url("../assets/search/bg.png")no-repeat center;height: 41px;line-height: 41px;width: 167px;}
    .leixing{width: 1200px;margin: 0 auto;}
    .leixing ul{display: flex;justify-content: space-around;flex-wrap: wrap;}
    .leixing ul li{margin: 10px;}
    .leixing ul li a{display:inline-block;width: 130px;height: 40px;line-height: 40px;background: #fff;text-align: center;font-size: 14px;border-radius: 5px;}
    /*�ײ�*/
    footer{height: 180px;background: #fff;padding: 70px 0 0;}
    footer p{font-size: 12px;color: #999;text-align: center;}


    main{
        background-color: #f7f7f7;
        padding: 46px 0 114px;
    }
    .container-md{width: 1200px;margin: 0 auto;overflow: hidden;}
    .main-content{
        display: flex;
        justify-content: space-between;
    }
    .main-content .left-list{
        width: 161px;
        padding: 40px;
        background: #fff;
        align-self: baseline;
    }
    .main-content .left-list h3{font-size:20px;text-align: left;margin-bottom: 25px;}
    .main-content .left-list ul{
        display: flex;
        flex-direction: column;
    }
    .main-content .left-list ul li{
        position: relative;
        padding-left:17px;
        margin: 15px 0;
        cursor: pointer;
    }
    .main-content .left-list ul li.curr{
        font-weight: bold;
    }
    .main-content .left-list ul li.curr:before{
        content:"";
        position: absolute;
        display: inline-block;
        width:4px;
        height:20px;
        background: #ff9f00;
        left:0;
        top:50%;
        margin-top:-10px;
    }
    .content-msg {
        width: 1027px;
    }
    .content-msg .top-msg{
        text-align: left;
        padding:37px 30px;
        background: #fff;
        margin-bottom: 14px;
    }
    .content-msg .top-msg h3{margin-bottom:30px;}
    .content-msg .top-msg ul{
        display: flex;
    }
    .content-msg .top-msg ul li{
        margin-right: 20px;
        font-size: 14px;
        cursor: pointer;
    }
    .content-msg .top-msg ul li span{
        display: inline-block;
        width:30px;
        height:30px;
        vertical-align: middle;
        margin-right: 5px;
    }
    .content-msg .top-msg ul li span.user{
        background: url("../assets/personal/user.png") no-repeat 0 0;
    }
    .content-msg .top-msg ul li span.money{
        background: url("../assets/personal/money.png") no-repeat 0 0;
    }
    .content-msg .top-msg ul li span.edit{
        background: url("../assets/personal/edit.png") no-repeat 0 0;
    }

    .content-msg .search-msg{background: #ffffff;padding:30px;}
    .content-msg .search-msg .search{
        display: flex;
        justify-content: space-between;
        padding-bottom: 30px;
    }
    .content-msg .search-msg .search .lt >>> .el-select{margin-right: 13px}
    .content-msg .search-msg .search .lt >>> .el-select .el-input,.content-msg .search-msg .search .lt >>> .el-input{
        position: relative;
        display: inline-block;
        font-size: 14px;
        text-align: left;
        padding:0 30px;
        width: 178px;
        height: 40px;
        line-height: 40px;
        background-color: #f7f7f7;
        border-radius: 20px;
    }
    .content-msg .search-msg .search .lt >>> .el-select .el-input input,.content-msg .search-msg .search .lt >>> .el-input input{
        border:none;
    }
    .content-msg .search-msg .search .lt span:before{
        content:"";
        position: absolute;
        display: inline-block;
        width:16px;
        height:16px;
        background: #f7f7f7 url("../assets/personal/arrow.png") no-repeat 0 0;
        right:15px;
        top:50%;
        margin-top:-8px;
    }
    .content-msg .search-msg .search .lt span.type{
        margin-right: 28px;
    }

    .content-msg .search-msg .search .rt {
        display: flex;
        line-height: 40px;
    }
    .content-msg .search-msg .search .rt .date {
        display: flex;
    }
    .content-msg .search-msg .search .rt .date span{
        width: 100px;
        height: 40px;
        background-color: #f7f7f7;
        border-radius: 20px;
    }
    .content-msg .search-msg .search .rt .date i{padding: 0 10px;}
    .content-msg .search-msg .search .rt .date span:before{
        content:'';
        display: inline-block;
        width:20px;
        height:20px;
        margin-right: 15px;
        background: #f7f7f7 url("../assets/personal/date.png") no-repeat 0 0;
        vertical-align: text-bottom;
    }

    .content-msg .search-msg .search .rt .bt{
        display: flex;
    }
    .content-msg .search-msg .search .rt .bt a{
        display: inline-block;
        font-size: 14px;
        color: #fff;
        width: 68px;
        height: 40px;
        background-color: #ff9f00;
        border-radius: 20px;
    }
    .content-msg .search-msg .search .rt .bt a:first-child{margin-right: 10px}
    .content-msg .search-msg .search .rt .bt a img{vertical-align: middle}

    .content-msg .search-msg .conditions{background: #fff;}
    .content-msg .search-msg .conditions ul{
        display: flex;
        height:36px;
        line-height: 36px;
        background: #f7f7f7;
    }
    .content-msg .search-msg .conditions li{
        font-size: 14px;
        color: #999999;
        padding:0 10px;
        margin:2px 0 2px 2px;
        background: #fff;
    }
    .content-msg .search-msg .conditions li span{
        margin-right: 4px;
        display: inline-block;
        width: 18px;
        height: 18px;
        vertical-align: middle;
    }
    .content-msg .search-msg span.all{
        margin-right: 8px;
        width: 20px;
        height: 20px;
        background: url("../assets/personal/select.png") no-repeat center center;
    }
    .content-msg .search-msg li span.all.curr{
        background: url("../assets/personal/select-hover.png") no-repeat center center;
    }
    .content-msg .search-msg .conditions li span.yes{
        background: url("../assets/personal/yes.png") no-repeat center center;
    }
    .content-msg .search-msg .conditions li span.down{
        background: url("../assets/personal/down.png") no-repeat center center;
    }

    .content-msg .search-msg .content{
        font-size: 12px;
        color: #999999;
        padding:30px 0 20px;
    }
    .content-msg .search-msg .content a{
        color: #3377aa;
    }
    .content-msg .search-msg .content li{
        display: flex;
        height:104px;
        justify-content: space-between;
        align-items: center;
    }
    .content-msg .search-msg .content li:not(:last-child){
        margin-bottom: 38px;
    }
    .content-msg .search-msg .content li img{
        width: 147px;
        height:100%;
        vertical-align: middle;
        margin:0 30px;
    }
    .content-msg .search-msg .content li .img{
        display: flex;
        align-items: center;
        height:100%;
    }
    .content-msg .search-msg .content li .img-msg{
        display: flex;
        text-align: left;
    }
    .content-msg .search-msg .content li .img-msg dl{
        margin-right: 20px;
    }
    .content-msg .search-msg .content li .img-msg dl dd:not(:last-child){
        margin-bottom: 8px;
    }
    .content-msg .search-msg .content li .is-pass a{
        margin-top: 8px;
    }
    .content-msg .search-msg .content li .download a
    {
        display: inline-block;
        margin-bottom: 8px;
    }
    .content-msg .search-msg .content li .is-pass,
    .content-msg .search-msg .content li .download{
        display: flex;
        align-items: center;
        flex-direction: column;
    }
    .content-msg .search-msg .content li .download{

        align-items: self-start;
    }
    .content-msg .search-msg .content li span.all{
        display: inline-block;
        width: 18px;
        height: 18px;
        vertical-align: middle;
        margin-right: 0;
    }

    .content-msg .search-msg .content.collection{
        display: flex;
    }
    .content-msg .search-msg .content.collection .date{margin-right: 23px}
    .content-msg .search-msg .content.collection .date p{
        color: #2a2a2a;
        font-weight: bold;
    }
    .content-msg .search-msg .content.collection .date p:first-child{
        font-size: 20px;
    }
    .content-msg .search-msg .content.collection ul{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }
    .content-msg .search-msg .content.collection li{
        height:auto;
        flex-wrap: wrap;
        margin-bottom: 13px;
        width:213px;
    }
    .content-msg .search-msg .content.collection li .operation{
        display: flex;
        width: 100%;
        justify-content: space-between;
        margin-top: 8px;
    }
    .content-msg .search-msg .content.collection li .operation a{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 57px;
        height: 18px;
        color: #999999;
        text-align: center;
        border-radius: 18px;
        border: 1px solid #999999;
    }
    .content-msg .search-msg .content.collection li .operation a img{
        width: 12px;
        height:12px;
        margin-left: 5px;
    }
    .content-msg .search-msg .content.collection .img{
        text-align: left;
        flex: auto;
    }
    .content-msg .search-msg .content.collection .img img,.content-msg .search-msg .content.collection .img video{
        margin:0;
        width:100%;
        height:151px;
        border-radius: 10px;
    }
    .content-msg .search-msg .content.collection .img p{
        font-size: 18px;
        color: #2a2a2a;
        margin-bottom: 10px;
    }
    .content-msg .search-msg .content.collection{}


    .popup-msg{
        text-align: left;
    }
    .popup-msg >>> .el-form-item{
        width: 361px;
        height: 48px;
    }
    .popup-msg h3{
        color: #2a2a2a;
        font-size: 20px;
        margin: 43px 0 45px;
    }
    .publicPopup >>> .el-dialog__header .el-dialog__close:before{
        content:'';
        display: inline-block;
        width:20px;
        height:20px;
        background: url("../assets/personal/cancel.png") no-repeat 0 0;
    }
    .publicPopup >>> .el-dialog__header .el-dialog__close:hover:before{
        background: url("../assets/personal/cancel-gray.png") no-repeat 0 0;
    }
    .publicPopup >>> .el-form-item{
        position: relative;
        background-color: #f7f7f7;
        border-radius: 24px;
        margin:0 auto;
        display: flex;
        align-items: center;
    }
    .publicPopup >>> .el-form-item:not(:last-child){
        margin-bottom:18px;
    }
    .publicPopup >>> .el-form-item .el-input__inner{
        border: none;
        background-color: #f7f7f7;
        border-radius: 24px;
        padding:0 0 0 10px;
    }
    .publicPopup >>> .el-form-item .el-form-item__label{
        margin-left:33px;
        padding:0;
    }
    .publicPopup >>> .el-dialog__wrapper .el-dialog{
        display: inline-block;
        width: auto;
        padding: 33px 76px 92px 56px;
        border-radius: 14px;
    }
    .publicPopup >>> .el-dialog__body{padding:0;}
    .publicPopup >>> .el-dialog__headerbtn{
        top: 33px;
        right: 36px;
    }
    .publicPopup >>> .el-dialog__header,
    .publicPopup >>> .el-dialog__footer{
        padding:0;
    }
    .popup-msg >>> .submit{
        color: #fff;
        width: 136px;
        height: 48px;
        background-color: #ff9f00;
        border-radius: 24px;
        border:none;
        margin-top: 25px;
    }
    .publicPopup >>> .el-form-item__content{
        position: static;
        flex: auto;
    }
    .publicPopup >>> .el-form-item__error{
        left: 20px;
    }
</style>
